import { createAction, props } from '@ngrx/store';
import { ODataResponse } from '@tdw/core';
import { PigFamily, PigFamilyConfiguration, PigProduct, PigProductGuideFilters } from 'src/app/models';
import { LookupValue } from 'src/app/models/lookup.model';

export const loadLookups = createAction('[PigProductGuide] Load Lookups');
export const loadLookupsSuccess = createAction('[PigProductGuide] Load Lookups Success', props<{ lookups: { families: PigFamily[], familyConfigs: PigFamilyConfiguration[], diameters: LookupValue[] } }>());
export const loadLookupsFailure = createAction('[PigProductGuide] Load Lookups Failure', props<{ error: any }>());

export const loadPigProducts = createAction('[PigProductGuide] Load PigProducts');
export const loadPigProductsSuccess = createAction('[PigProductGuide] Load PigProducts Success', props<{ pigProducts: ODataResponse<PigProduct[]> }>());
export const loadPigProductsFailure = createAction('[PigProductGuide] Load PigProducts Failure', props<{ error: any }>());


export const loadCutSheet = createAction('[PigProductGuide] Load CutSheet', props<{ id: number }>());
export const loadCutSheetSuccess = createAction('[PigProductGuide] Load CutSheet Success');
export const loadCutSheetFailure = createAction('[PigProductGuide] Load CutSheet Failure', props<{ error: any }>());

export const changeFilter = createAction('[PigProductGuide] change filters', props<{ vals: Partial<PigProductGuideFilters> }>());
export const clearFilter = createAction('[PigProductGuide] clear filters');

export const goToPage = createAction('[PigProductGuide] go to page', props<{ page: number }>());
